import React from "react";
import {
  InformfixService,
  HomeService,
  ProjectService,
  AuthService,
  TechnicainService,
} from "./../../../services";
import {
  Button,
  Select,
  message,
  Dropdown,
  Menu,
  Popconfirm,
  Form,
  Card,
  PageHeader,
  Row,
  Col,
  Input,
  List,
  Modal,
  Divider,
  Tooltip,
  Space,
  DatePicker,
  Spin,
  Badge,
  Avatar,
  Pagination,
  Tabs,
} from "antd";
import _ from "lodash";
import { Config } from "./../../../config/index";
import "./style.scss";
import PaginationDetail from "../../PaginationDetail";
import queryString from "query-string";

import { inject, Observer } from "mobx-react";
import InformFormAdd from "./../inform-form";
import InformEdit from "./../inform-edit";
import AssignJob from "./../assign-job";
import InformView from "./../inform-view";
import NotificationAdd from "./../../notification/notification-form";
import { Moment, strlimit, openNotificationWithIcon } from "../../../helpers";
import {
  PlusCircleOutlined,
  MenuFoldOutlined,
  SearchOutlined,
  ReloadOutlined,
  ClockCircleFilled,
  EditFilled,
  CloseCircleFilled,
  CalendarFilled,
  UserOutlined,
  HomeFilled,
  FileDoneOutlined,
  WifiOutlined,
  PhoneFilled,
  HomeOutlined,
  EditOutlined,
  CalendarOutlined,
  CloseOutlined,
  PhoneOutlined,
  BellOutlined,
} from "@ant-design/icons";
import { InformfixStatus } from "../InformfixStatus";
import iconHome from "../../../assets/images/informfix/icon-home.png";
import InformListComponent from "../InformListComponent";
import { DashboardService } from "../../../services/dashboard.service";
const { TabPane } = Tabs;
const IconText = ({ icon, text, onClickAction }) => (
  <React.Fragment>
    {icon} {text}
  </React.Fragment>
);

const { Option } = Select;
const formatDateSearch = "DD/MM/YYYY";

const STATUS_INFORMFIX_OPEN = Config.informfix.status.OPEN.value; //  สถานะใบแจ้งซ่อม: เปิดงาน
// const STATUS_INFORMFIX_WAIT = Config.informfix.status.WAIT.value; //  สถานะใบแจ้งซ่อม: รอยืนยันลูกค้า
// const STATUS_INFORMFIX_CONFIRMED = Config.informfix.status.CONFIRMED.value; //  สถานะใบแจ้งซ่อม: ยืนยันลูกค้าแล้ว
const STATUS_INFORMFIX_PROCEED = Config.informfix.status.PROCEED.value; // สถานะใบแจ้งซ่อม: กำลังดำเนินการ  สำหรับใช้แสดงหน้าจัดคิวงาน
const STATUS_INFORMFIX_COMPLETE = Config.informfix.status.COMPLETE.value; //  สถานะใบแจ้งซ่อม: เสร็จแล้ว

@inject("informStore")
@Observer
class InformListPostpone extends React.Component {
  constructor() {
    super();
    this.state = {
      initLoading: true,
      loading: false,
      loadingProject: false,
      list: [],
      showFormAdd: false,
      showFormEdit: false,
      showFormAssign: false,
      showFormView: false,
      editId: "",
      viewId: "",
      searchParams: {
        project_id: "",
        work_status: STATUS_INFORMFIX_OPEN,
        q: "",
        f: "id",
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: Config.pager.limit,
        pageCount: 0,
      },
      homeDetail: {},
      inform: {},
      informJobs: [],
      galleries: [],
      photos: [],
      confirmLoading: false,
      projects: [],
      listStatus: [],
      listTechnichian: [],
      visibleMenuDropDown: false,
      formStep: "",
      countWorkstatus: [],
    };
  }

  formRef = React.createRef();

  setPageParams(params) {
    this.setState({
      pagination: {
        current: params.currentPage,
        total: params.totalCount,
        pageSize: params.perPage,
        pageCount: params.pageCount,
      },
    });
  }

  /**
   * แสดงข้อมูลตาม Filter ที่เลือกไว้
   */
  getData = () => {
    const { searchParams, pagination } = this.state;
    searchParams.postpone_mark = 2;
    const params = {
      page: pagination ? pagination.current : 1,
      "per-page": pagination ? pagination.pageSize : Config.pager.limit,
      postpone_mark: searchParams.postpone_mark,
    };
    this.props.informStore.setItems([]);
    this.setState({
      list: [],
      pagination: {
        current: 1,
        total: 0,
        pageSize: Config.pager.limit,
        pageCount: 0,
      },
    });

    return InformfixService.search(params);
  };

  /**
   * ดึงข้อมุลใบแจ้งซ๋อมตามหน้าที่กำหนด
   */
  loadDataPagination = () => {
    this.setState({
      initLoading: true,
      list: [],
    });
    this.getData()
      .then((rs) => {
        const data = rs.data["items"];
        const pager = rs.data["_meta"];
        this.setPageParams(pager);
        this.props.informStore.setItems(data);
        this.setState(
          {
            list: data,
            initLoading: false,
          },
          () => {
            window.dispatchEvent(new Event("resize"));
          }
        );
      })
      .catch((err) => {
        if (err.response) {
          const code = err.response.status;
          if (code === 404) {
            // message.warning(err.response.statusText);
          }
        }
        this.setState({ initLoading: false, list: [] });
        this.props.informStore.setItems([]);
      });
  };

  /**
   * ดึงข้อมุลใบแจ้งซ๋อมแบบเริ่มที่หน้า 1 และรีเซ็ต Filter ใหม่หมด
   */
  getItems = () => {
    let pagination = this.state.pagination;
    pagination.current = 1;
    pagination.total = 0;
    pagination.pageSize = Config.pager.limit;
    pagination.pageCount = 0;
    this.setState({
      pagination,
      initLoading: true,
      list: [],
    });

    this.getData()
      .then((rs) => {
        const data = rs.data["items"];
        const pager = rs.data["_meta"];
        this.setPageParams(pager);
        this.props.informStore.setItems(data);
        this.setState(
          {
            // data: data,
            list: data,
            initLoading: false,
          },
          () => {
            window.dispatchEvent(new Event("resize"));
          }
        );
      })
      .catch((err) => {
        if (err.response) {
          const code = err.response.status;
          if (code === 404) {
            // message.warning(err.response.statusText);
          }
        }
        this.setState({ initLoading: false, list: [] });
      });
  };

  onSearch = () => {
    this.setState({
      list: [],
    });
    this.getItems();
  };

  componentDidMount() {
    this.onSearch();
  }

  resetForm() {
    this.formRef.current.resetFields();
    this.setState({
      data: [],
      list: [],
      pagination: {
        current: 1,
        total: 0,
        pageSize: this.state.pagination.perPage,
        pageCount: 0,
      },
    });
    this.onSearch();
  }

  /**
   * นับสถานะใบแจ้งซ่อม
   */
  getCountAllStatus() {
    console.log("check count inform");
    InformfixService.countNewInform().then((rs) => {
      if (rs) {
        console.log("countNewInform", rs.data);
        const data = rs.data;
        this.props.informStore.countNewInform = data.total;
      }
    });
    InformfixService.count4task().then((rs) => {
      console.log("count4task", rs);
      if (rs) {
        const data = rs.data;
        this.props.informStore.count4task = data.total;
      }
    });
    InformfixService.countPostpone().then((rs) => {
      if (rs) {
        console.log("countPostpone", rs.data);
        const data = rs.data;
        this.props.informStore.countPostpone = data.total;
      }
    });
  }

  render() {
    const {
      initLoading,
      loading,
      loadingProject,
      pagination,
      homeDetail,
      inform,
      projects,
      listStatus,
      searchParams,
      galleries,
      photos,
    } = this.state;

    const loadMore =
      !initLoading &&
      !loading &&
      pagination &&
      pagination.current < pagination.pageCount ? (
        <div
          style={{
            textAlign: "center",
            marginTop: 12,
            height: 32,
            lineHeight: "32px",
          }}
        >
          <Button
            type={Config.button.loadMore.type}
            block={Config.button.loadMore.block}
            shape={Config.button.loadMore.shape}
            onClick={this.onLoadMore}
            loading={loading}
          >
            {Config.button.loadMore.text}
          </Button>
        </div>
      ) : null;

    return (
      <React.Fragment>
        <p>
          <Button
            onClick={() => this.onSearch()}
            icon={<ReloadOutlined />}
          ></Button>
        </p>
        <PaginationDetail data={pagination} />
        
        <InformListComponent
          items={this.props.informStore.getItems}
          showMenu={{
            editInform: true,
            cancelInform: true,
            confirmInform: true,
            postponeJob: true,
            deleteInform: true,
          }}
          onWorkstatusChange={(data) => {
            this.getCountWorkstatus();
          }}
          showFormAdd={this.state.showFormAdd}
          onFormAddClose={(value) => {
            this.setState({
              showFormAdd: value,
            });
            this.getCountWorkstatus();
          }}
          manageInform
          reload={() => this.onSearch()}
        />

        <PaginationDetail data={pagination} />
        <Pagination
          showQuickJumper
          defaultCurrent={1}
          current={this.state.pagination.current}
          total={this.state.pagination.total}
          pageSize={this.state.pagination.pageSize}
          onChange={(page, pageSize) => {
            let pagination = this.state.pagination;
            pagination.current = page;
            pagination.pageSize = pageSize;
            this.setState({
              pagination,
            });
            this.loadDataPagination();
          }}
          onShowSizeChange={(page, pageSize) => {
            let pagination = this.state.pagination;
            pagination.current = page;
            pagination.pageSize = pageSize;
            this.setState({
              pagination,
            });
            this.loadDataPagination();
          }}
        />
      </React.Fragment>
    );
  }
}

export default InformListPostpone;
